import { Checkbox, Grid, Popover } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { DownArrowBlackIcon, UpArrowBlackIcon } from "../../icon";


interface IProps {
    AllFilters?: {
        FilterCatogaryLabel: string,
        MultiSelection?: boolean,
        FilterHeaders: {
            Label: string,
            Selected: boolean,
            Icon?: any
        }[],
    }[];
    PopOverClasses?: string;
    CatogaryClasses?: string;
    CheckBoxClasses?: string;
    FilterLabelClasses?: string;
    OnClose: () => void;
    ApplySelectedFilters: (filters) => void;
}


const ConversationCardsFilterComponent: React.FC<IProps> = (Props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);

    const [allFilters, setAllFilters] = useState(Props.AllFilters)
    const [anchor, setAnchor] = useState(null)
    const [openedFilter, setOpenedFilter] = useState<string>("")


    const handleFilter = (selectedLabel: string) => {

        let selectedFilters = []

        selectedFilters = allFilters.map(x => {
            return {
                ...x, FilterHeaders: x.FilterHeaders.map(y => {
                    return { ...y, Selected: x.MultiSelection ? (y.Label === selectedLabel ? !y.Selected : y.Selected) : (x.FilterHeaders.map(x => x.Label).includes(selectedLabel) ? y.Label === selectedLabel : y.Selected) }
                })
            }
        })

        setAllFilters(selectedFilters)
        Props.ApplySelectedFilters(selectedFilters)
    }

    const handleCloseFilter = () => {
        setAnchor(null)
        setOpenedFilter("")
    }

    return (
        <div className={`${Props.PopOverClasses ? Props.PopOverClasses : `bg-color-secondary d-flex flex-direction ${IsMobileDevice ? "px-3" : "w-100"}`} `}>
            {
                IsMobileDevice ?
                    <div className="pt-2">
                        <div className="h3-medium pb-1">
                            Filters
                        </div>
                        <div className="bb-primary-divider-4 "></div>
                        {allFilters.filter(x => !x.FilterCatogaryLabel).map(x => {
                            return (
                                <Grid>
                                    <div className={`${Props.PopOverClasses ? Props.PopOverClasses : "h5-semibold ml-2"} mt-2`}>{x.FilterCatogaryLabel}</div>
                                    {x.FilterHeaders.map(y => {
                                        return (
                                            <div className={" d-flex font-bold w-p-100 mt-1"}>
                                                <Checkbox
                                                    name="checkbox"
                                                    onChange={() => handleFilter(y.Label)}
                                                    classes={{ checked: "selected-checkbox" }}
                                                    checked={y.Selected}
                                                    className="m-0 p-0"
                                                    size="small"
                                                />
                                                <span className={`d-flex justify-center align-center  mr-1  ${y.Icon && ""} `}>{y.Icon}</span>
                                                <span className={`my-auto h4-medium color-primary-accent`}>{y.Label}</span>
                                            </div>
                                        )
                                    })
                                    }
                                </Grid>
                            )
                        })
                        }
                        <Grid className="d-flex w-p-100" container>
                            {allFilters.filter(x => !!x.FilterCatogaryLabel).map(x => {
                                return (
                                    <Grid className="w-p-50" item>
                                        <div className={`${Props.PopOverClasses ? Props.PopOverClasses : "h5-semibold"} mt-2`}>{x.FilterCatogaryLabel}</div>
                                        {x.FilterHeaders.map(y => {
                                            return (
                                                <div className={" d-flex font-bold w-p-100 mt-1"}>
                                                    <Checkbox
                                                        name="checkbox"
                                                        onChange={() => handleFilter(y.Label)}
                                                        classes={{ checked: "selected-checkbox" }}
                                                        checked={y.Selected}
                                                        className="m-0 p-0"
                                                        size="small"
                                                    />
                                                    <span className={`d-flex justify-center align-center  mr-1  ${y.Icon && "ml-2"} `}>{y.Icon}</span>
                                                    <span className={`my-auto h4-medium color-primary-accent`}>{y.Label}</span>
                                                </div>
                                            )
                                        })
                                        }
                                    </Grid>
                                )
                            })
                            }
                        </Grid>
                    </div>
                    :
                    <div className="d-flex w-p-100 my-auto">
                        {allFilters.map(x => {
                            return (
                                <div className="w-14 login-border h-4 br-3 mx-1 d-flex align-center justify-center h5-medium c-pointer" onClick={(e) => { setAnchor(e.currentTarget); setOpenedFilter(x.FilterCatogaryLabel) }}>
                                    {x.MultiSelection ? x.FilterCatogaryLabel : x.FilterHeaders.find(x => x.Selected)?.Label}{(!!x.FilterHeaders.find(x => x.Selected) && x.MultiSelection) ? `(${x.FilterHeaders.filter(x => x.Selected).length})` : ""}
                                    {x.FilterCatogaryLabel === openedFilter ? <UpArrowBlackIcon className="ml-1 w-2 h-2" /> : <DownArrowBlackIcon className="ml-1 w-2 h-2" />}
                                </div>
                            )
                        })
                        }
                        {
                            openedFilter &&
                            <Popover
                                open={openedFilter === openedFilter}
                                anchorEl={anchor}
                                onClose={handleCloseFilter}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                                classes={{ paper: `max-h-44 w-17 br-2` }}
                            >
                                {allFilters.find(x => x.FilterCatogaryLabel === openedFilter).FilterHeaders.map(y => {
                                    const multiselect = allFilters.find(x => x.FilterCatogaryLabel === openedFilter).MultiSelection
                                    return (
                                        <div className={" d-flex w-p-100 my-1 pl-1 c-pointer "} onClick={() => handleFilter(y.Label)}>
                                            {multiselect &&
                                                <Checkbox
                                                    name="checkbox"
                                                    classes={{ checked: "selected-checkbox" }}
                                                    checked={y.Selected}
                                                    className="m-0 p-0"
                                                    size="small"
                                                />
                                            }
                                            <span className={`d-flex justify-center align-center  mr-1  ${y.Icon && "ml-1"} `}>{y.Icon}</span>
                                            <span className={`my-auto h5-medium color-primary-accent`}>{y.Label}</span>
                                        </div>
                                    )
                                })
                                }
                            </Popover>
                        }
                    </div>
            }
        </div >
    )
}

export default ConversationCardsFilterComponent;